import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";
import { FileuploadService } from "src/app/services/fileupload.service";
declare var bootstrap: any;
import { GoogleMap } from "@angular/google-maps";
import { BaseComponent } from "../base.component";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "app-institute-registration",
  templateUrl: "./institute-registration.component.html",
  styleUrls: ["./institute-registration.component.css"],
})
export class InstituteRegistrationComponent
  extends BaseComponent
  implements OnInit {
  InstitutionRegCertificate: String = "";
  countryCode: string = "336";
  submitted = false;
  currentStep = 1;
  selectedType: string | null = null;
  formData: any = {};
  instituteRegDtls: any = {};
  counties: string[] = [];
  subCountiesData: string[] = [];
  currentYear: number = new Date().getFullYear();
  @ViewChild("myModal") modalElement!: ElementRef;
  @ViewChild("fileInputRef1") fileInputRef1!: ElementRef;
  isEdit: boolean = false;
  tnt_code: string;
  editData: any = {};
  tenants: Array<any> = [];
  country: any[] = [];
  file: File;
  fileName: string;
  labelName: any = {};
  headingName: any = {};
  County: Array<any> = [];
  ApplicationType: Array<any> = [];
  subCounty: Array<any> = [];
  Constituency: Array<any> = [];
  levels: Array<any> = [];
  beForm: Boolean = false;
  higherForm: Boolean = false;
  tvetForm: Boolean = false;
  userDetails: any = {};
  modalInstance: any;
  userData: any;
  sneType: any = "";
  sneDetail: string = "0";
  registrationType: string = "new";
  registrationTypeValue: any = "new";
  categories: Array<any> = [];
  sneCategoriesList: any[] = [];
  selectedSneDetails: any[] = [];
  subSneCategoriesList: any[] = [];
  selectedSubSneDetails: any[] = [];
  dropdownSettings: any = {};
  subDropdownSettings: any = {};
  showSubSneDropdown: boolean = false;
  registrationNumber: string = "";
  isSave: boolean = false;
  institution_level = 1;
  is_valid_certificate: boolean = true;
  isDataProtectionChecked: boolean = false;
  private subscriptions: Subscription[] = [];

  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  zoom = 15;
  markerPosition: google.maps.LatLngLiteral | null = null;
  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    animation: google.maps.Animation.DROP,
    icon: {
      url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      scaledSize: new google.maps.Size(40, 40),
    },
  };

  getTypeLabel(type: string): string {
    switch (type) {
      case "basic":
        return "Basic Education";
      case "tvet":
        return "TVET";
      case "higher":
        return "Higher Education";
      default:
        return "";
    }
  }

  getTypeDescription(type: string): string {
    switch (type) {
      case "basic":
        return "Primary and Secondary Schools";
      case "tvet":
        return "Technical and Vocational Education";
      case "higher":
        return "Universities and Colleges";
      default:
        return "";
    }
  }

  instituteRegForm = this.fb.group({
    TNT_NAME: ["", Validators.required],
    TNT_DESCRIPTION: ["", Validators.required],
    TNT_CONCURRENT_AVSESSIONS: ["", Validators.required],
    TNT_USERSPERSESSION: ["", Validators.required],
    email: [
      "",
      [
        Validators.required,
        Validators.pattern(
          "^(?!.*\\.\\.)(?!.*@\\.)([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$",
        ),
      ],
    ],
    tnt_admin_name: ["", Validators.required],
    mobileno: [
      "",
      [
        Validators.required,
        Validators.pattern(/^[0-9]{9,12}$/),
        Validators.minLength(9),
        Validators.maxLength(12),
      ],
    ],
    schoollocation: ["", [Validators.required, Validators.required]],
    schoollevel: ["", Validators.required],
    TNT_PARENT_CODE: [""],
    SHOWLOGO: [false],
    allow_proctoring: [false],
    allow_exampad: [false],
    constituency: [{ value: null, disabled: true }],
    simba_acc: [""],
    gpa_accno: [""],
    bankbranch: [""],
    bankname: [""],
    noofnonteaching_female: ["0"],
    noofnonteaching_male: ["0"],
    noofteaching_female: ["0"],
    noofteaching_male: ["0"],
    noofteaching_total: [{ value: 0, disabled: true }],
    noofnonteaching_total: [{ value: 0, disabled: true }],
    learnerenrolment_total: [{ value: 0, disabled: true }],
    accommodation_type: [null],
    gpi: ["0"],
    landmark: [""],
    applicationtype: [null, Validators.required],
    registration_no: ["", Validators.required],
    tnt_sne_capacity: ["0", Validators.required],
    tnt_registration_certificate: ["", Validators.required],
    tnt_boys_capacity: ["0"],
    tnt_girls_capacity: ["0"],
    tnt_sne_boyscapacity: ["0"],
    tnt_sne_girlscapacity: ["0"],
    school_regno: [""],
    enrollment_boys: ["0"],
    enrollment_girls: ["0"],
    schoolnameincertificate: [""],
    latitude: [{ value: "", disabled: true }, Validators.required],
    longitude: [{ value: "", disabled: true }, Validators.required],
    sne_disabilitytype_otherdescription: [""],
    reregistration_reasons: ["", Validators.required],
    institution_type: ["", Validators.required],
    subscriptionid: [""],
    school_categories: ["", Validators.required],
    mobilenocode_countryid: ["336"],
    mobilenocode_countryName: [],
    is_valid_certificate: [true],
  });

  get fc() {
    return this.instituteRegForm.controls;
  }

  constructor(
    protected CommonService: CommonService,
    private fb: UntypedFormBuilder,
    private active: ActivatedRoute,
    private router: Router,
    protected toastr: ToastrService,
    private FileuploadService: FileuploadService,
  ) {
    super(CommonService, toastr);
    active.queryParams.subscribe((res) => {
      this.tnt_code = res.tntCode;
    });
    this.countyDropdowns();
    this.ApplicationDropdowns();
    this.getLevels();
    this.getSchoolCategories();
    this.getCurrentLocation();

    this.active.queryParams.subscribe((res: any) => {
      if (res.screen == "IR") {
        (this.selectInstitutionType("basic"), this.nextStep());
        this.instituteRegForm.get("email")?.setValue(res.email);
        this.checkEmail(res.email, "IR");
      }
    });
  }

  ngOnInit(): void {
    if (this.tnt_code) {
      this.isEdit = true;
      this.getData();
    }
    this.calculateTotals();

    this.dropdownSettings = {
      singleSelection: false,
      idField: "SNE_CATEGORY_ID",
      textField: "SNE_CATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.subDropdownSettings = {
      singleSelection: false,
      idField: "SNE_SUBCATEGORY_ID",
      textField: "SNE_SUBCATEGORY_NAME",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.ChangeSC();
    this.loadCountry();

    this.ClearValidations("new");

    this.instituteRegForm
      .get("institution_type")
      ?.valueChanges.subscribe((value) => {
        const boys = this.instituteRegForm.get("tnt_boys_capacity");
        const girls = this.instituteRegForm.get("tnt_girls_capacity");
        const sneGirls = this.instituteRegForm.get("tnt_sne_girlscapacity");
        const sneBoys = this.instituteRegForm.get("tnt_sne_boyscapacity");

        if (value == "1") {
          girls?.reset();
          sneGirls?.reset();
        } else if (value == "2") {
          boys?.reset();
          sneBoys?.reset();
        }

        boys?.clearValidators();
        girls?.clearValidators();
        sneGirls?.clearValidators();
        sneBoys?.clearValidators();

        if (value == "1") {
          boys?.setValidators([Validators.required]);
          girls?.setValue(0);
          sneGirls?.setValue(0);
        } else if (value == "2") {
          girls?.setValidators([Validators.required]);
          boys?.setValue(0);
          sneBoys?.setValue(0);
        } else if (value == "3") {
          boys?.setValidators([Validators.required]);
          girls?.setValidators([Validators.required]);
          sneGirls?.setValidators([Validators.required]);
          sneBoys?.setValidators([Validators.required]);
        }

        boys?.updateValueAndValidity();
        girls?.updateValueAndValidity();
        sneGirls?.updateValueAndValidity();
        sneBoys?.updateValueAndValidity();

        this.calculateTotalSneCapacity();
      });

    // Subscribe to regular capacity field changes with debounce
    this.subscriptions.push(
      this.instituteRegForm
        .get("tnt_boys_capacity")
        ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(() => {
          this.calculateTotalSneCapacity();
        }),
    );

    this.subscriptions.push(
      this.instituteRegForm
        .get("tnt_girls_capacity")
        ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(() => {
          this.calculateTotalSneCapacity();
        }),
    );

    // Subscribe to SNE capacity field changes with debounce
    this.subscriptions.push(
      this.instituteRegForm
        .get("tnt_sne_boyscapacity")
        ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(() => {
          this.calculateTotalSneCapacity();
        }),
    );

    this.subscriptions.push(
      this.instituteRegForm
        .get("tnt_sne_girlscapacity")
        ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(() => {
          this.calculateTotalSneCapacity();
        }),
    );

    this.instituteRegForm
      .get("is_valid_certificate")
      ?.valueChanges.subscribe((value) => {
        this.updateCertificateValidators(value);
      });

    this.updateCertificateValidators(this.is_valid_certificate);
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  calculateTotalSneCapacity(): void {
    const institutionType =
      this.instituteRegForm.get("institution_type")?.value;

    // Use setTimeout to ensure we get the latest values after all pending updates
    setTimeout(() => {
      const boysCapacity = parseInt(
        this.instituteRegForm.get("tnt_boys_capacity")?.value || "0",
        10,
      );
      const girlsCapacity = parseInt(
        this.instituteRegForm.get("tnt_girls_capacity")?.value || "0",
        10,
      );
      const sneBoysCapacity = parseInt(
        this.instituteRegForm.get("tnt_sne_boyscapacity")?.value || "0",
        10,
      );
      const sneGirlsCapacity = parseInt(
        this.instituteRegForm.get("tnt_sne_girlscapacity")?.value || "0",
        10,
      );

      let total = this.userData?.tnt_sne_capacity || 0;

      if (institutionType === "1") {
        total = boysCapacity + sneBoysCapacity;
      } else if (institutionType === "2") {
        total = girlsCapacity + sneGirlsCapacity;
      } else if (institutionType === "3") {
        total =
          boysCapacity + sneBoysCapacity + girlsCapacity + sneGirlsCapacity;
      }

      // Only update if the value has changed to avoid unnecessary updates
      const currentTotal = parseInt(
        this.instituteRegForm.get("tnt_sne_capacity")?.value || "0",
        10,
      );
      if (currentTotal !== total) {
        this.instituteRegForm
          .get("tnt_sne_capacity")
          ?.setValue(total.toString(), { emitEvent: false });
      }
    }, 0);
  }

  updateCertificateValidators(value: boolean): void {
    const registrationNoControl = this.instituteRegForm.get("registration_no");
    const registrationCertControl = this.instituteRegForm.get(
      "tnt_registration_certificate",
    );

    if (value === true) {
      registrationNoControl?.setValidators([Validators.required]);
      registrationCertControl?.setValidators([Validators.required]);
    } else {
      registrationNoControl?.clearValidators();
      registrationCertControl?.clearValidators();
      registrationNoControl?.setValue("");
      this.registrationNumber = "";
      this.InstitutionRegCertificate = "";
      registrationCertControl?.setValue("");

      if (this.fileInputRef1) {
        this.fileInputRef1.nativeElement.value = "";
      }
    }

    registrationNoControl?.updateValueAndValidity();
    registrationCertControl?.updateValueAndValidity();
  }

  onCertificateChange(value: string): void {
    this.is_valid_certificate = value === "yes";
    this.instituteRegForm
      .get("is_valid_certificate")
      ?.setValue(this.is_valid_certificate);
  }

  checkRegNo(regNo: any) {
    if (this.is_valid_certificate === true && regNo) {
      this.activeSpinner();
      this.CommonService.postCall(
        "TenantRegistration/CheckTenantRegistrationNo",
        { registration_no: regNo },
      ).subscribe(
        (res: any) => {
          if (res && res.status === false) {
            this.toastr.warning(res.message);
            this.instituteRegForm.get("registration_no")?.setValue("");
            this.deactivateSpinner();
          }
        },
        (err) => {
          this.toastr.error(
            err.message ? err.message : "Unable to Fetch Details",
          );
          this.deactivateSpinner();
        },
      );
      this.deactivateSpinner();
    }
  }

  ClearValidations(type: string) {
    if (type == "new") {
      this.instituteRegForm?.get("reregistration_reasons")?.clearValidators();
      this.instituteRegForm
        ?.get("school_categories")
        ?.setValidators([Validators.required]);
    } else {
      this.instituteRegForm
        ?.get("reregistration_reasons")
        ?.setValidators([Validators.required]);
      this.instituteRegForm?.get("school_categories")?.clearValidators();
    }
    this.instituteRegForm
      ?.get("reregistration_reasons")
      ?.updateValueAndValidity();
    this.instituteRegForm?.get("school_categories")?.updateValueAndValidity();
  }

  loadCountry() {
    this.activeSpinner();
    this.country = [];
    this.CommonService.postCall("ClustersMaster/GetCountryList", {}).subscribe(
      (res: any) => {
        this.country = res;
        this.countryCode = "336";
        this.deactivateSpinner();
      },
      (e) => {
        this.deactivateSpinner();
      },
    );
  }

  selectInstitutionType(type: string): void {
    this.selectedType = type;
    if (type == "higher" || type == "tvet") {
      this.instituteRegForm.get("email")?.clearValidators();
      this.instituteRegForm.get("mobileno")?.clearValidators();
      this.instituteRegForm.get("email")?.updateValueAndValidity();
      this.instituteRegForm.get("mobileno")?.updateValueAndValidity();
    }
  }

  clearQueryParams() {
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true,
    });
  }

  nextStep() {
    if (this.selectedType) {
      this.currentStep++;
    }
  }

  previousStep() {
    this.clearQueryParams();
    this.currentStep--;
    if (this.currentStep == 1) {
      this.instituteRegForm.setValue({
        TNT_NAME: "",
        TNT_STATUS: true,
        TNT_PARENT_CODE: "",
        TNT_DESCRIPTION: "",
        TNT_CONCURRENT_AVSESSIONS: "",
        TNT_USERSPERSESSION: "",
        TenantLogoUrl: "",
        SHOWLOGO: false,
        allow_proctoring: false,
        allow_exampad: false,
        constituency: "0",
        simba_acc: "",
        gpa_accno: "",
        bankbranch: "",
        bankname: "",
        noofnonteaching_female: "0",
        noofnonteaching_male: "0",
        noofteaching_female: "0",
        noofteaching_male: "0",
        noofteaching_total: 0,
        noofnonteaching_total: 0,
        learnerenrolment_total: 0,
        accommodation_type: "",
        email: "",
        gpi: "",
        landmark: "",
        applicationtype: "",
        school_regno: "",
        schoollocation: "",
        enrollment_boys: "0",
        enrollment_girls: "0",
        schoollevel: "",
        schoolnameincertificate: "",
        latitude: "",
        longitude: "",
        mobileno: "",
        sne_disabilitytype_otherdescription: "",
        is_valid_certificate: true,
      });
      this.sneType = "";
      this.sneDetail = "0";
      this.is_valid_certificate = true;
    }
  }

  completeRegistration() {
    this.currentStep = 3;
  }

  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner();
  }

  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(
      `TenantRegistration/GetLabelValuesByTaskid/81/${localStorage.getItem(
        "TenantCode",
      )}`,
    ).subscribe((res: any) => {
      this.labelName = res;
      console.log(res);
    });
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(
      `EmsDynamicheadingLables/GetLabelValuesByTaskid/81/${localStorage.getItem(
        "TenantCode",
      )}`,
    ).subscribe((res: any) => {
      this.headingName = res;
    });
  }

  getData() {
    this.activeSpinner();
    this.CommonService.postCall("EditTenant", {
      TNT_CODE: this.tnt_code,
    }).subscribe((res: any) => {
      this.deactivateSpinner();
      if (res instanceof Array) {
        this.editData = res[0];
        this.dataTransfer(res[0]);
      } else {
        this.editData = res;
        this.dataTransfer(res);
      }
    });
  }

  dataTransfer(data) {
    let ctrls = this.instituteRegForm.controls;
    Object.keys(ctrls).map((key) => {
      let ctrl = ctrls[key];
      if (key === "is_valid_certificate" && data[key] !== undefined) {
        this.is_valid_certificate =
          data[key] === true || data[key] === "true" || data[key] === 1;
        this.updateCertificateValidators(this.is_valid_certificate);
      }
      ctrl.setValue(data[key]);
    });
    ctrls["TNT_KEY"].setValue(moment(data["TNT_KEY"]).format("yyyy-MM-DD"));
    this.calculateTotalSneCapacity();
  }

  onDataProtectionCheckboxChange() {
    this.isDataProtectionChecked == true ? false : true;
  }

  onSubmit(form: UntypedFormGroup) {

    this.submitted = true;
    if (this.isDataProtectionChecked == false) {
      this.toastr.warning("Please Check Data Protection Policy");
      return;
    }
    if (this.instituteRegForm.invalid) {
      this.instituteRegForm.markAllAsTouched();
      this.toastr.warning("Please Enter Mandatory Fields");
    } else {
      if (
        this.selectedSneDetails.length == 0 &&
        (this.sneType == 2 || this.sneType == 3 || this.sneType == 4)
      ) {
        return this.toastr.warning(
          "At least one record must be selected from Integrated.",
        );
      }
      let value = Object.assign({}, form.getRawValue());
      value["TNT_CREATEDBY"] = 54039871;
      value["TNT_PARENT_CODE"] = 90076444;
      value["TNT_KEY"] = "2027-06-30";
      value["school_category_id"] = this.sneType;
      value["sne_category_id"] = this.selectedSneDetails
        .map((x: any) => x.SNE_CATEGORY_ID)
        .join(",");
      value["sne_subcategory_id"] = this.selectedSubSneDetails
        .map((x: any) => x.SNE_SUBCATEGORY_ID)
        .join(",");
      value["registration_type"] = this.registrationTypeValue == "new" ? 1 : 2;
      value["reregistration_reasons"] = value.reregistration_reasons || 0;
      value["TNT_STATUS"] = true;
      value["subscriptionid"] = this.levels.find(
        (e) => e.level_id == value.schoollevel,
      ).subscriptionid;
      value["allow_proctoring"] = false;
      value["allow_exampad"] = false;
      value["enrollment_boys"] = 0;
      value["enrollment_girls"] = 0;
      value["noofteaching_male"] = 0;
      value["noofteaching_total"] = 0;
      value["noofteaching_female"] = 0;
      value["noofnonteaching_male"] = 0;
      value["noofnonteaching_total"] = 0;
      value["noofnonteaching_female"] = 0;
      value["TenantLogoUrl"] = "";
      value["accommodation_type"] =
        value["accommodation_type"] == null || value["accommodation_type"] == ""
          ? 0
          : value["accommodation_type"];
      if (this.registrationTypeValue == 2) {
        value["constituency"] = 0;
        value["applicationtype"] = "";
        value["accommodation_type"] = 0;
      }
      value["institution_level"] = this.institution_level;

      if (value.is_valid_certificate === false) {
        value.registration_no = "";
        value.tnt_registration_certificate = "";
      }

      delete value.school_categories;

      this.activeSpinner();
      this.isSave = true;
      if (this.isEdit) {
        value["TNT_CODE"] = 90076444;
        this.CommonService.postCall("UpdateTenant", value).subscribe(
          (res: any) => {
            this.toastr.success("Tenant Updated Successfully");
            this.deactivateSpinner();
          },
          (err) => {
            this.deactivateSpinner();
            this.toastr.error(err.error ? err.error : "Tenant not Updated");
            this.isSave = false;
          },
        );
      } else {
        this.CommonService.postCall("SaveTenant", value).subscribe(
          (res: any) => {
            this.toastr.success(
              `${this.registrationNumber == "" || this.registrationNumber == null
                ? "Institution details saved"
                : "Institution details updated"
              } Successfully.`,
            );
            this.deactivateSpinner();
            this.submitted = false;
            this.router.navigate(["/payment"], {
              queryParams: {
                typ: 10,
                wId: 0,
                uId: 54039871,
                stTnt: res?.TNT_CODE,
                tntName: res?.TNT_NAME,
                email: res?.email,
                screen: "IR",
              },
            });
          },
          (err) => {
            this.deactivateSpinner();
            // this.toastr.error(
            //   err.message 
            // );
            this.submitted = false;
            this.isSave = false;
          },
        );
      }
    }
  }

  close() {
    window.history.back();
  }

  getTenantData() {
    let payLoad = {
      Decrypt_Role: localStorage.getItem("RoleId"),
      TNT_CODE: localStorage.getItem("TenantCode"),
    };
    this.activeSpinner();
    this.CommonService.postCall("LoadTenantByRoleId", payLoad).subscribe(
      (res: any) => {
        this.deactivateSpinner();
        this.tenants = res;
      },
      (err) => {
        this.deactivateSpinner();
      },
    );
  }

  changeFile(event) {
    if (event.target.files.length > 0) {
      let file: File = event.target.files[0];
      let name = file.name;
      let filetype = name.split(".").pop();
      let types: Array<any> = ["png", "jpg", "PNG", "jpeg", "gif", "JPEG"];
      let check = types.includes(filetype);
      if (check) {
        this.file = file;
        this.upload();
      } else {
        this.toastr.warning("Please upload image file formats only.");
        event.target.value = "";
      }
    }
  }

  upload() {
    if (!this.file) return;
    const formData = new FormData();
    formData.append("file", this.file);
    formData.append("ClientDocs", "ClientDocs");

    this.activeSpinner();
    this.FileuploadService.upload(formData, "UploadTenant").subscribe(
      (res: any) => {
        this.fileName = res.FilePath;
        if (this.fileName && res.FilePath) {
          this.deactivateSpinner();
          this.instituteRegForm.controls["TenantLogoUrl"].setValue(
            this.fileName,
          );
        }
      },
      (err) => {
        this.toastr.warning(err.error ? err.error : "file not uploaded");
        this.deactivateSpinner();
      },
    );
  }

  countyDropdowns() {
    this.County = [];
    this.CommonService.postCall("ClustersMaster/GetCountiesListByKenya", {
      COUNTRY_NAME: "Kenya",
    }).subscribe(
      (res: any) => {
        this.County = res;
        this.County = this.County.filter((x) => x.STATUS == true);
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No County's found!");
      },
    );
  }

  ApplicationDropdowns() {
    this.ApplicationType = [];
    this.CommonService.postCall("TenantRegistration/GetActiveApplicationType", {
      tnt_code: 90076444,
    }).subscribe(
      (res: any) => {
        this.ApplicationType = res;
        // this.County = this.County.filter((x) => x.STATUS == true);
      },
      (err: any) => {
        return this.toastr.error(err.error ? err.error : "No Application Type's found!");
      },
    );
  }

  subCounties(SubCountyId: any) {
    this.subCounty = [];
    this.CommonService.postCall("ClustersMaster/GetSubCountiesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.subCounty = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Sub-County's found!");
      },
    );
    this.CommonService.postCall("ClustersMaster/GetCountyconstituenciesList", {
      counties_id: SubCountyId,
    }).subscribe(
      (res: any) => {
        this.Constituency = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No Constituency found!");
      },
    );
  }

  getLevels() {
    this.levels = [];
    this.CommonService.postCall("TenantRegistration/GetSchoolLevel", {
      tenantcode: 90076444,
      registration_type: 2,
    }).subscribe((res: any) => {
      this.levels = res;
    });
  }

  getForm(type: string) {
    this.beForm = type === "be";
    this.higherForm = type === "higherForm";
    this.tvetForm = type === "tvetForm";
  }

  // validateEmail(event: any): void {
  //   const val = event.target.value.trim();
  //   // const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
  //   const emailPattern = /^(?!.*\.\.)(?!.*@\.)((?!\.)[a-z0-9._%+-]+)@[a-z0-9-]+(\.[a-z]{2,})+$/i;

  //   if (!emailPattern.test(val)) {
  //     this.instituteRegForm.get("email")?.setValue("");
  //     this.toastr.warning("Invalid Email, Please Input a Valid Email Address.");
  //     return;
  //   }

  //   const domain = val.split("@")[1];
  //   if (/\d/.test(domain)) {
  //     this.instituteRegForm.get("email")?.setValue("");
  //     this.toastr.warning(
  //       'Numbers are not allowed in the domain part of the email (after "@").',
  //     );
  //     return;
  //   }
  // }
  validateEmail(event: any): void {
    const val = event.target.value.trim();

    const emailPattern =
      /^(?!.*\.\.)(?!.*@@)(?!.*\.@)(?!.*@\.)(?!.*[._%+-]{2})[A-Za-z0-9]+([._%+-][A-Za-z0-9]+)*@[A-Za-z0-9]+([.-][A-Za-z0-9]+)*\.[A-Za-z]{2,}$/;

    if (!emailPattern.test(val)) {
      this.instituteRegForm.get("email")?.setValue("");
      this.toastr.warning("Please enter a valid email address.");
      return;
    }
  }
  validateEmailKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const key = event.key;

    const specialChars = [".", "_", "%", "+", "-", "@"];

    const lastChar = value.slice(-1);

    // Prevent ..
    if (key === "." && lastChar === ".") {
      event.preventDefault();
      return;
    }

    // Prevent @@
    if (key === "@" && lastChar === "@") {
      event.preventDefault();
      return;
    }

    // Prevent .@
    if (key === "@" && lastChar === ".") {
      event.preventDefault();
      return;
    }

    // Prevent @.
    if (key === "." && lastChar === "@") {
      event.preventDefault();
      return;
    }

    // Prevent special character immediately after another special character
    if (specialChars.includes(key) && specialChars.includes(lastChar)) {
      event.preventDefault();
      return;
    }
  }
  ChangeSC() {
    if (
      this.instituteRegForm?.get("TNT_USERSPERSESSION").value != "" &&
      this.instituteRegForm?.get("TNT_USERSPERSESSION").value != null
    ) {
      this.instituteRegForm?.get("constituency").enable();
    } else {
      this.instituteRegForm?.get("constituency").setValue("0");
      this.instituteRegForm?.get("constituency").disable();
    }
  }

  openPreviewModal() {
    const selectedCategoryNames = this.selectedSneDetails
      .map((item: any) => item.SNE_CATEGORY_NAME)
      .join(", ");
    const selectedSUbCategoryNames = this.selectedSubSneDetails
      .map((item: any) => item.SNE_SUBCATEGORY_NAME)
      .join(",");

    this.userDetails = {
      ...this.instituteRegForm.value,
      sne_disability_status: this.sneType,
      sne_disability_type_names: selectedCategoryNames,
      sne_subCategories_names: selectedSUbCategoryNames,
      registration_number: this.registrationNumber,
      latitude: this.instituteRegForm.get("latitude").value,
      longitude: this.instituteRegForm.get("longitude").value,
      email: this.instituteRegForm.get("email").value,
      tnt_admin_name: this.instituteRegForm.get("tnt_admin_name").value,
      COUNTIES_NAME: this.County.find(
        (e) =>
          e.COUNTIES_CODE ==
          this.instituteRegForm.get("TNT_CONCURRENT_AVSESSIONS").value,
      )?.COUNTIES_NAME,
      SUB_COUNTIES_NAME: this.subCounty.find(
        (e) =>
          e.sub_counties_id ==
          this.instituteRegForm.get("TNT_USERSPERSESSION").value,
      )?.sub_counties_name,
      mobilenocode_countryName: this.country.find(
        (c: any) => c.COUNTRY_ID == 336,
      )?.COUNTRY_CONNECTING_CODE,
    };

    if (!this.modalInstance) {
      this.modalInstance = new bootstrap.Modal(this.modalElement.nativeElement);
    }

    this.modalInstance.show();
  }

  getLevelDescription(id: number | string): string {
    const level = this.levels.find((l) => l.level_id == id);
    return level ? level.level_desc : "";
  }

  getApplicationTypeName(id: number | string): string {
    const applicationType = this.ApplicationType.find((l) => l.applicationtype_id == id);
    return applicationType ? applicationType.applicationtype_name : "";
  }

  getConstituencyList(id: number | string): string {
    const constituencyList = this.Constituency.find(
      (l) => l.con_counties_id == id,
    );
    return constituencyList ? constituencyList.con_counties_name : "";
  }

  checkInstitutionName(event: any, ctrl: string = "") {
    if (event?.target.value != "") {
      this.activeSpinner();
      this.CommonService.postCall("TenantRegistration/GetTenantByTenantName", {
        TNT_NAME: ctrl == "" ? event?.target.value : event,
      }).subscribe(
        (res: any) => {
          if (res.status) {
          } else {
            this.toastr.error(res.message);
            this.instituteRegForm.patchValue({
              TNT_NAME: "",
            });
          }
          this.deactivateSpinner();
        },
        (e) => {
          if (
            e.error
              ? this.toastr.error(e.error.message)
              : "Institution Name Already Exist"
          ) {
            this.instituteRegForm.patchValue({
              TNT_NAME: "",
            });
            this.toastr.error(e.error.message);
          }
          this.deactivateSpinner();
        },
      );
    }
  }

  checkEmail(event: any, ctrl: string = "") {
    this.activeSpinner();
    this.CommonService.postCall("TenantRegistration/GetTenantByEmail", {
      email: ctrl == "" ? event?.target.value : event,
    }).subscribe(
      (res: any) => {
        if (res.message) {
          this.toastr.error(res.message);
          this.instituteRegForm.patchValue({
            email: "",
          });
          this.deactivateSpinner();
          return;
        }
        if (res.length) {
          this.getSchoolCategories();
          this.userData = res[0];
          this.instituteRegForm.patchValue({
            TNT_NAME: res[0].TNT_NAME || "",
            TNT_STATUS: res[0].TNT_STATUS ?? true,
            TNT_PARENT_CODE: res[0].TNT_PARENT_CODE || "",
            TNT_DESCRIPTION: res[0].TNT_DESCRIPTION || "",
            TNT_CONCURRENT_AVSESSIONS: res[0].TNT_CONCURRENT_AVSESSIONS || "",
            TNT_USERSPERSESSION: res[0].TNT_USERSPERSESSION || "",
            tnt_admin_name: res[0].tnt_admin_name || "",
            TenantLogoUrl: res[0].TenantLogoUrl || "",
            SHOWLOGO: res[0].SHOWLOGO ?? false,
            allow_proctoring: res[0].allow_proctoring ?? false,
            allow_exampad: res[0].allow_exampad ?? false,
            simba_acc: res[0].simba_acc || "",
            gpa_accno: res[0].gpa_accno || "",
            bankbranch: res[0].bankbranch || "",
            bankname: res[0].bankname || "",
            noofnonteaching_female: res[0].noofnonteaching_female || "0",
            noofnonteaching_male: res[0].noofnonteaching_male || "0",
            noofteaching_female: res[0].noofteaching_female || "0",
            noofteaching_male: res[0].noofteaching_male || "0",
            snetype: res[0].snetype || "",
            accommodation_type: res[0].accommodation_type || "",
            gpi: res[0].gpi || "",
            landmark: res[0].landmark || "",
            applicationtype: res[0].applicationtype || "0",
            school_regno: res[0].school_regno || "",
            schoollocation: res[0].schoollocation || "",
            enrollment_boys: res[0].enrollment_boys || "0",
            enrollment_girls: res[0].enrollment_girls || "0",
            schoollevel: res[0].schoollevel || "",
            schoolnameincertificate: res[0].schoolnameincertificate || "",
            latitude: res[0].latitude || "",
            longitude: res[0].longitude || "",
            mobileno: res[0].mobileno || "",
            constituency: res[0].constituency || "0",
            noofteaching_total: res[0]?.noofteaching_total,
            noofnonteaching_total: res[0]?.noofnonteaching_total,
            learnerenrolment_total: res[0]?.learnerenrolment_total,
            sne_disability_status: res[0]?.sne_disability_status,
            sne_disability_type: res[0]?.sne_disability_type,
            sne_disabilitytype_otherdescription:
              res[0]?.sne_disabilitytype_otherdescription,
            institution_type: res[0]?.institution_type,
            registration_no: res[0]?.registration_no,
            tnt_sne_capacity: res[0]?.tnt_sne_capacity,
            tnt_registration_certificate: res[0]?.tnt_registration_certificate,
            tnt_boys_capacity: res[0]?.tnt_boys_capacity,
            tnt_girls_capacity: res[0]?.tnt_girls_capacity,
            tnt_sne_boyscapacity: res[0]?.tnt_sne_boyscapacity,
            tnt_sne_girlscapacity: res[0]?.tnt_sne_girlscapacity,
            school_categories: res[0]?.school_category_id,
            is_valid_certificate:
              res[0]?.is_valid_certificate === true ||
              res[0]?.is_valid_certificate === "true" ||
              res[0]?.is_valid_certificate === 1,
          });
          this.InstitutionRegCertificate = res[0]?.tnt_registration_certificate;
          this.ChangeSC();

          if (res[0]?.is_valid_certificate !== undefined) {
            this.is_valid_certificate =
              res[0].is_valid_certificate === true ||
              res[0].is_valid_certificate === "true" ||
              res[0].is_valid_certificate === 1;
            this.updateCertificateValidators(this.is_valid_certificate);
          }

          this.subCounties(res[0]?.TNT_CONCURRENT_AVSESSIONS);
          this.calculateTotalSneCapacity();
        }
        this.deactivateSpinner();
      },
      (e) => {
        if (
          e.error ? this.toastr.error(e.error.message) : "Email Already Exist"
        ) {
          this.instituteRegForm.patchValue({
            email: "",
          });
          this.toastr.error(e.error.message);
        }
        this.deactivateSpinner();
      },
    );
  }

  calculateTotals() {
    this.instituteRegForm
      .get("noofteaching_male")!
      .valueChanges.subscribe(() => this.updateTeachingTotal());
    this.instituteRegForm
      .get("noofteaching_female")!
      .valueChanges.subscribe(() => this.updateTeachingTotal());

    this.instituteRegForm
      .get("noofnonteaching_male")!
      .valueChanges.subscribe(() => this.updateNonTeachingTotal());
    this.instituteRegForm
      .get("noofnonteaching_female")!
      .valueChanges.subscribe(() => this.updateNonTeachingTotal());

    this.instituteRegForm
      .get("enrollment_boys")!
      .valueChanges.subscribe(() => this.updateEnrollmentTotal());
    this.instituteRegForm
      .get("enrollment_girls")!
      .valueChanges.subscribe(() => this.updateEnrollmentTotal());
  }

  updateTeachingTotal() {
    const male = +this.instituteRegForm.get("noofteaching_male")!.value || 0;
    const female =
      +this.instituteRegForm.get("noofteaching_female")!.value || 0;
    this.instituteRegForm
      .get("noofteaching_total")!
      .setValue(male + female, { emitEvent: false });
  }

  updateNonTeachingTotal() {
    const male = +this.instituteRegForm.get("noofnonteaching_male")!.value || 0;
    const female =
      +this.instituteRegForm.get("noofnonteaching_female")!.value || 0;
    this.instituteRegForm
      .get("noofnonteaching_total")!
      .setValue(male + female, { emitEvent: false });
  }

  updateEnrollmentTotal() {
    const boys = +this.instituteRegForm.get("enrollment_boys")!.value || 0;
    const girls = +this.instituteRegForm.get("enrollment_girls")!.value || 0;
    this.instituteRegForm
      .get("learnerenrolment_total")!
      .setValue(boys + girls, { emitEvent: false });
  }

  onRegistrationTypeChange(type: string) {
    this.registrationTypeValue = type;
    this.registrationType = type;
    if (type === "re") {
      this.instituteRegForm.reset();
      this.instituteRegForm.patchValue({
        TNT_CONCURRENT_AVSESSIONS: "",
        TNT_USERSPERSESSION: "",
        schoollevel: "",
        accommodation_type: "",
        applicationtype: "",
        is_valid_certificate: true,
      });
      this.sneType = "";
      this.registrationNumber = "";
      this.is_valid_certificate = true;
      this.updateCertificateValidators(true);
    } else {
      this.instituteRegForm.reset();
      [
        "email",
        "TNT_CONCURRENT_AVSESSIONS",
        "TNT_USERSPERSESSION",
        "school_regno",
      ].forEach((field) => this.instituteRegForm.get(field)?.enable());
      this.instituteRegForm.get("reregistration_reasons")?.clearValidators();
      this.instituteRegForm
        .get("reregistration_reasons")
        ?.updateValueAndValidity();
      this.registrationNumber = "";
      this.is_valid_certificate = true;
      this.updateCertificateValidators(true);
    }
    this.ClearValidations(type);
  }

  ClearData() {
    this.instituteRegForm.patchValue({
      TNT_NAME: "",
      TNT_DESCRIPTION: "",
      TNT_CONCURRENT_AVSESSIONS: "",
      TNT_USERSPERSESSION: "",
      tnt_admin_name: "",
      email: "",
      mobileno: "",
      schoollocation: "",
      schoollevel: "",
      TNT_PARENT_CODE: "",
      SHOWLOGO: false,
      allow_proctoring: false,
      allow_exampad: false,
      constituency: 0,
      simba_acc: "",
      gpa_accno: "",
      bankbranch: "",
      bankname: "",
      noofnonteaching_female: 0,
      noofnonteaching_male: 0,
      noofteaching_female: 0,
      noofteaching_male: 0,
      noofteaching_total: 0,
      noofnonteaching_total: 0,
      learnerenrolment_total: 0,
      accommodation_type: "",
      gpi: 0,
      landmark: "",
      applicationtype: "",
      school_regno: "",
      enrollment_boys: 0,
      enrollment_girls: 0,
      schoolnameincertificate: "",
      latitude: "",
      longitude: "",
      sne_disabilitytype_otherdescription: "",
      reregistration_reasons: "",
      institution_type: "",
      school_categories: "",
      mobilenocode_countryid: "336",
      is_valid_certificate: true,
    });
    this.is_valid_certificate = true;
    this.updateCertificateValidators(true);
    this.ChangeSC();
    this.calculateTotalSneCapacity();
  }

  onPostalCodeInput(event: any): void {
    const input = event.target;
    const sanitized = input.value.replace(/[^0-9]/g, "");
    this.instituteRegForm
      .get("TNT_DESCRIPTION")
      ?.setValue(sanitized, { emitEvent: false });
  }

  onMobileInput(event: any): void {
    const input = event.target;
    const sanitized = input.value.replace(/[^0-9]/g, "");
    this.instituteRegForm
      .get("mobileno")
      ?.setValue(sanitized, { emitEvent: false });
  }

  getSchoolCategories() {
    this.categories = [];
    this.CommonService.postCall(
      "TenantRegistration/GetSchoolCategoryList",
      {},
    ).subscribe((res: any) => {
      this.categories = res;
    });
  }

  getSneCategoryList() {
    this.sneCategoriesList = [];
    this.selectedSneDetails = [];
    this.CommonService.postCall("TenantRegistration/GetSneCategoryList", {
      SCHOOL_CATEGORY_ID: this.sneType,
    }).subscribe((res: any) => {
      this.sneCategoriesList = res;
    });
  }

  onSneDetailChange() {
    const targetIds = ["12", "13", "17"];
    const matchedIds = this.selectedSneDetails
      .map((x: any) => x.SNE_CATEGORY_ID?.toString())
      .filter((id: string) => targetIds.includes(id))
      .map((id) => +id);

    if (matchedIds.length > 0) {
      this.showSubSneDropdown = true;
      this.getSubSneCategoryList(matchedIds);
    } else {
      this.showSubSneDropdown = false;
      this.subSneCategoriesList = [];
      this.selectedSubSneDetails = [];
    }
  }

  shouldShowSneBlock(): boolean {
    const relevantCategories = [
      "Hearing Impairment",
      "Visual Impairment",
      "Specific learning disabilities",
    ];
    const selected = this.userDetails?.sne_category_names?.split(", ") || [];
    return selected.some((cat) => relevantCategories.includes(cat));
  }

  getSubSneCategoryList(categoryIds: number[]) {
    this.subSneCategoriesList = [];
    this.CommonService.postCall("TenantRegistration/GetSubSneCategoryList", {
      SNE_CATEGORY_IDS: categoryIds.join(","),
    }).subscribe((res: any) => {
      this.subSneCategoriesList = res;
    });
  }

  getDetailsByRegistrationNumber(): void {
    this.activeSpinner();

    this.CommonService.postCall(
      "TenantRegistration/GetInstitutionsByRegistrationNo",
      { REGISTRATION_NO: this.registrationNumber },
    ).subscribe((res: any) => {
      if (!res) {
        this.deactivateSpinner();
        return;
      }

      [
        "email",
        "TNT_CONCURRENT_AVSESSIONS",
        "TNT_USERSPERSESSION",
        "school_regno",
      ].forEach((field) => this.instituteRegForm.get(field)?.disable());

      this.instituteRegDtls = res;
      this.instituteRegForm.patchValue({
        TNT_NAME: res.TNT_NAME || "",
        TNT_STATUS: res.TNT_STATUS ?? true,
        TNT_PARENT_CODE: res.TNT_PARENT_CODE || "",
        TNT_DESCRIPTION: res.TNT_DESCRIPTION || "",
        TNT_CONCURRENT_AVSESSIONS: res.TNT_CONCURRENT_AVSESSIONS || "",
        TNT_USERSPERSESSION: res.TNT_USERSPERSESSION || "",
        tnt_admin_name: res.tnt_admin_name || "",
        email: res.email || "",
        snetype: res.snetype || "",
        accommodation_type: res.accommodation_type || "",
        gpi: res.gpi || "",
        landmark: res.landmark || "",
        applicationtype: res.applicationtype || "",
        school_regno: res.school_regno || "",
        schoollocation: res.schoollocation || "",
        schoollevel: res.schoollevel || "",
        schoolnameincertificate: res.schoolnameincertificate || "",
        latitude: res.latitude || "",
        longitude: res.longitude || "",
        mobileno: res.mobileno || "",
        constituency: res.constituency || "0",
        sne_disability_status: res.sne_disability_status || null,
        sne_disability_type: res.sne_disability_type || null,
        sne_disabilitytype_otherdescription:
          res.sne_disabilitytype_otherdescription || "",
        institution_type: res.institution_type,
        mobilenocode_countryid: res.mobilenocode_countryid,
        is_valid_certificate:
          res.is_valid_certificate === true ||
          res.is_valid_certificate === "true" ||
          res.is_valid_certificate === 1,
      });
      this.sneType = res.school_category_id || "";

      if (res.is_valid_certificate !== undefined) {
        this.is_valid_certificate =
          res.is_valid_certificate === true ||
          res.is_valid_certificate === "true" ||
          res.is_valid_certificate === 1;
        this.updateCertificateValidators(this.is_valid_certificate);
      }

      this.subCounties(res?.TNT_CONCURRENT_AVSESSIONS || "");
      this.calculateTotalSneCapacity();

      this.deactivateSpinner();
    });
  }

  getCurrentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.zoom = 15;

        this.markerPosition = { ...this.center };
        this.instituteRegForm.patchValue({
          latitude: this.center.lat,
          longitude: this.center.lng,
        });
      });
    }
  }

  onMapClick(event: google.maps.MapMouseEvent): void {
    if (event.latLng) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      this.markerPosition = { lat, lng };
      this.instituteRegForm.patchValue({
        latitude: lat,
        longitude: lng,
      });
    }
  }

  GoToLogin() {
    this.router.navigate(["/login"]);
  }

  goBack() {
    this.router.navigate(["/login"]);
  }

  changeFileForMuiltiple(event: any, type: number) {
    if (event.target.files.length > 0) {
      const file: File = event.target.files[0];
      const name = file.name;
      const ext = name.split(".").pop()?.toLowerCase();
      const allowed = ["pdf"];

      if (!allowed.includes(ext || "")) {
        this.toastr.warning("Please upload PDF files only.");
        event.target.value = "";
        return;
      }
      this.file = file;
      this.uploadFile(type);
    }
  }

  uploadFile(type: number) {
    if (!this.file) return;

    this.activeSpinner();

    const formData = new FormData();
    formData.append("upload_1", this.file);
    formData.append("DIRECTORY_NAME", "refundDocuments");

    this.FileuploadService.upload(
      formData,
      "Registration/UploadTenantRegistrationFile",
    ).subscribe(
      (res: any) => {
        this.deactivateSpinner();

        const uploadedPath = res.path;
        switch (type) {
          case 1:
            this.InstitutionRegCertificate = uploadedPath;
            this.instituteRegForm.patchValue({
              tnt_registration_certificate: uploadedPath,
            });
            break;
        }

        this.instituteRegForm.updateValueAndValidity();
        this.toastr.success("File uploaded successfully");
      },
      (err) => {
        this.deactivateSpinner();
        this.toastr.error("Upload Failed");
      },
    );
  }

  getFileUrl(path: string): string {
    return path;
  }

  openDocument(documentType: string, item: any) {
    if (!documentType) return;

    let filePath = "";
    switch (documentType) {
      case "InstitutionRegCertificate":
        filePath = item.fee_receipt;
        break;
    }
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      charCode === 8 ||
      charCode === 46 ||
      charCode === 9 ||
      charCode === 27 ||
      charCode === 13
    ) {
      return true;
    }
    if (
      (charCode === 65 ||
        charCode === 67 ||
        charCode === 86 ||
        charCode === 88) &&
      event.ctrlKey === true
    ) {
      return true;
    }
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  // Removed the 10000 capacity limit - now just sanitizes the input
  validateMaxCapacity(event: any, field: string) {
    let value = event.target.value;
    if (value) {
      // Remove leading zeros
      value = value.replace(/^0+/, "");
      if (value === "") value = "0";

      // Just set the value without any max limit check
      event.target.value = value;
      this.instituteRegForm.get(field)?.setValue(value, { emitEvent: true });
    }
  }

  // Just formats the number by removing leading zeros
  formatNumberOnBlur(field: string) {
    const control = this.instituteRegForm.get(field);
    let value = control?.value;
    if (value && value !== "0") {
      value = parseInt(value, 10).toString();
      control?.setValue(value, { emitEvent: true });
    }
  }
}
